export const CURRENCYCODE = [
    { Name: "Svenska kronor", Value: "SEK" },
    { Name: "Euro", Value: "EUR" },
  ];